export default {
  home: 'home',
  statistics: 'statistics',
  Permissions: 'Permissions',
  insurance: 'Insurance',
  transportation: 'Transportation',
  veterinary: 'veterinary',
  events: 'Events',
  marketplace: 'marketplace',
  wallet: 'E-wallet',
  favourite: 'favourite',
  comments: 'my comments',
  settings: 'settings',
  insuranceDetails: 'insurance details',
  insuranceNow: 'insurance now',
  transportationNow: 'request trip',
  transportationDetails: 'transportation details',
  shopping: 'shopping',
  orders: 'orders',
  searchHere: 'search here',
  company: 'company',
  status: 'status',
  lastEnter: 'last enter date',
  documented: 'documented',
  veterinaryDetails: 'Veterinary Details',
  emptyFavourite: 'You don\'t have a favorite yet',
  goHomepage: 'Go To Home Page',
  paymentErrorMsg: 'Error occurred during payment.',
  successPayment: 'Payment done successfully.',
  reservations: 'Reservations',
  wallet_balance: 'Wallet balance'
}
